/**
 * What a clinic page says when it cannot show its record: why, a Try again when waiting might
 * help, and the way back to the screen the person came from.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import { ErrorState } from "@lattice/ui/ErrorState";
import { LinkButton } from "@lattice/ui/LinkButton";
import { navigate } from "../router.ts";
import { ClinicShell } from "./Shell.tsx";
export function NotOpened({
  title,
  body,
  retry = false,
  back
}: {
  readonly title: string;
  readonly body: string;
  /** Offers Try again, which reloads the page. */
  readonly retry?: boolean;
  readonly back: {
    readonly label: string;
    readonly href: string;
  };
}) {
  return <ClinicShell title="Clinic" signedIn>
      <ErrorState variant="page" title={title} body={body} {...retry ? {
      onRetry: () => window.location.reload()
    } : {}} />
      <div className="x78zum5 x1a02dak x626il7">
        <LinkButton href={back.href} tone="quiet" corners="rounded" navigate={navigate}>
          {back.label}
        </LinkButton>
      </div>
    </ClinicShell>;
}